import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import PlatformPage from "@/pages/PlatformPage";
import SecurityPage from "@/pages/SecurityPage";
import AboutPage from "@/pages/AboutPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import CaseStudyDetailPage from "@/pages/CaseStudyDetailPage";
import ContactPage from "@/pages/ContactPage";
import Navbar from "@/components/Navbar";
import ScrollToTop from "@/components/scrolltotop";   
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App min-h-screen" style={{ backgroundColor: "#050508" }}>
      <BrowserRouter>
        <ScrollToTop />   {/* ✅ add this */}
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/platform" element={<PlatformPage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/case-studies/:id" element={<CaseStudyDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;